<template>
  <div>
    <div id="toggle-template-bar">
      <div class="relative">
        <div class="flex items-center">
          <ul>
            <li
              class="toogle-template-button template pb-2"
              :class="{'active': searchBy == 'template'}"
              @click="_toggleSearchBy('template')"
            >
              <span>{{ $i18nPresenter.t('Templates') }}</span>
              <span class="total-result">{{ getTotalTemplateNumber }}</span>
            </li>
            <li
              class="toogle-template-button presentation ml-8 pb-2"
              :class="{'active': searchBy == 'presentation'}"
              @click="_toggleSearchBy('presentation')"
            >
              <span>{{ $i18nPresenter.t('My Presentations') }}</span>
              <span class="total-result">{{ getTotalPresentationNumber }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="mb-4 border-b border-secondary-20"></div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import utils from '@/util'
import constants from '@/constant'

const { eventCategories } = constants
export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapState({
      searchBy: (state) => state.search.searchBy,
      totalTemplate: (state) => state.search.totalTemplates,
      totalPresentation: (state) => state.search.totalPresentations,
    }),
    getTotalTemplateNumber() {
      if (this.totalTemplate && this.totalTemplate > 0) return ` ${this.totalTemplate}`
      return ' 0'
    },
    getTotalPresentationNumber() {
      if (this.totalPresentation && this.totalPresentation > 0) return ` ${this.totalPresentation}`
      return ' 0'
    },
  },

  methods: {
    ...mapActions(['setSelectedSearchByAction']),
    _toggleSearchBy(type) {
      if (!type) return
      this.setSelectedSearchByAction(type)
      const query = {
        q: this.$route.query.q,
      }
      if (type === 'presentation') {
        if (this.$route.name !== 'Presentations') {
          utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'WhenSearching > SwitchTab', '')
          this.$router.push({
            name: 'Presentations',
            query,
          })
        }
      } else if (type === 'template') {
        if (this.$route.name !== 'TemplateLibrary') {
          utils.mixpanelTracking(eventCategories.TEMPLATE_LIBRARY, 'WhenSearching > SwitchTab', '')
          query.from = 'toggleTemplateBar'
          this.$router.push({
            name: 'TemplateLibrary',
            query,
          })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.toogle-template-button {
  cursor: pointer;
  float: left;
}

.toogle-template-button span {
  font-size: 1rem;
  @media (max-width: 480px) {
    font-size: 14px;
  }
  @media (max-width: 375px) {
    font-size: 12px;
  }
  line-height: 1.25rem;
  font-weight: bold;
}

.toogle-template-button.active {
  border-bottom: 3px solid #348EF6;
  color: #348EF6 !important;
}
.total-result {
  @apply text-secondary-40;
}
</style>
